// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_93444fe79c--wrapper--IopGS","wrapper_redesign":"_93444fe79c--wrapper_redesign--2ek4Q"};